import { Component, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { initialStatus, loadingStatus } from '../../../../../core/models/request-status.model';
import { TableProConfig } from '../../../../../components/table-pro/core/table-pro.model';
import { PriceMediaStatusRequest } from '../../core/price-media.model';
import { PriceMediaService } from '../../core/price-media.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

enum EXPORT_TYPES {
  XLSX = 'table_rows',
  TXT = 'docs',
  CSV = 'csv',
}

@Component({
  selector: 'price-media-history',
  templateUrl: './price-media-history.component.html',
  styleUrl: './price-media-history.component.scss',
  standalone: false,
})
export class PriceMediaHistoryComponent implements OnDestroy {
  selectedExportType: EXPORT_TYPES = EXPORT_TYPES.XLSX;
  subscription = new Subscription();
  priceMediasRequest$ = new BehaviorSubject<PriceMediaStatusRequest>({
    ...initialStatus,
  });

  tableConfig: TableProConfig = {
    collumnConfig: [
      { id: 'id', index: 0, type: 'text' },
      { id: 'customerNumber', index: 1, type: 'text' },
      { id: 'requestDate', index: 2, type: 'date' },
      { id: 'effectiveDate', index: 3, type: 'date' },
      { id: 'formatType', index: 4, type: 'text' },
      { id: 'exportType', index: 5, type: 'text' },
      { id: 'status', index: 6, type: 'text' },
    ],
  };

  constructor(
    protected fb: FormBuilder,
    private priceMediaService: PriceMediaService,
  ) {}

  form: FormGroup = this.fb.group({
    fromDate: [null, [Validators.required]],
    toDate: [null, [Validators.required]],
  });

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getPriceMedias(): void {
    this.form.markAllAsTouched();

    if (this.form.invalid) return;

    const query = this.buildQuery();

    this.priceMediasRequest$.next({ ...loadingStatus });

    this.subscription.add(
      this.priceMediaService.getPriceMedias(query).subscribe(response => {
        this.priceMediasRequest$.next(response);
      }),
    );
  }

  buildQuery() {
    const { fromDate, toDate } = this.form.value;
    const formattedFromDate = new Date(fromDate).toISOString().split('T')[0];
    const formattedToDate = new Date(toDate).toISOString().split('T')[0];

    return {
      fromDate: formattedFromDate,
      toDate: formattedToDate,
    };
  }

  getExportTypeValueFrom(type: string) {
    this.selectedExportType = EXPORT_TYPES[type as keyof typeof EXPORT_TYPES];
    return this.selectedExportType.valueOf();
  }
}
